export const SHOP_TAGS_INITIAL_LIMIT = 5
